import React, { useEffect, useRef, useState } from 'react';
import { Footer as ScufFooter } from '@scuf/common';
import "./Footer.scss"
import { getDetailedView } from "src/slices/allOpportunitySlice";
import { useSelector } from 'react-redux';
import FontIcon from '../FontIcon/FontIcon';
import { getMessage } from '../../message/utils';
import { getConfigMsg } from 'src/slices/onBoardingSlice';

const Footer = () => {
    useSelector(getConfigMsg);
    const [showFooter, setShowFooter] = useState(false);
    const detailedView = useSelector(getDetailedView);
    const footerRef = useRef<any>(null);
    const [footerHeight,setFooterHeight] = useState(0);
    
    const style = showFooter
      ? { translate: '0 0' }
      : { translate: `0 ${footerHeight === 0 ? 100 : footerHeight + 1}px` };
      
    const privacy: string = getMessage('app.footer.privacy');
    const personalInfo: string = getMessage('app.footer.personalinfo');
    const cookies: string = getMessage('app.footer.cookies');
    const globalUnsubscribe: string = getMessage('app.footer.globalunsubscribe');
    const copyright1: string = getMessage('app.footer.copyright1');
    const copyright2: string = getMessage('app.footer.copyright2');

    const footerClassName = detailedView.length > 0 ? "detail-view-footer" : "footerDiv"
    const onFooterClick = () => setShowFooter(prevState => !prevState)

    useEffect(() => {
        const element = footerRef?.current;    
        if (!element) return;
    
        const observer = new ResizeObserver(() => {
          const footerHeight = footerRef?.current?.offsetHeight ?? 0;
          setFooterHeight(footerHeight)
        });
    
        observer.observe(element);
        return () => {
          observer.disconnect();
        };
      }, [])

    return (
            <div  className={`${footerClassName} ${showFooter?'show':'hide'}`} style={style}>
            <div className='footer-arrow'>
                <FontIcon className={`arrow-icon ${showFooter ? 'show' : 'hide'}`} iconName='fa-angle-up' onClick={onFooterClick} />
            </div>
            <div ref={footerRef}>
            <ScufFooter copyrightText={`${copyright1}${new Date().getFullYear()} ${copyright2}`}>
                <ScufFooter.Item href="https://sharepoint.honeywell.com/sites/PolicyManual/GPPS/GPPSHome.html?pn=2006&pl=en" target="_blank" >{privacy}</ScufFooter.Item>
                <ScufFooter.Item href="https://honeywellhub.secure.force.com/PrivacyInformationRequestForm?lang=en" >{personalInfo}</ScufFooter.Item>
                <ScufFooter.Item href="https://www.honeywell.com/en-us/privacy-statement#en-heading9" >{cookies}</ScufFooter.Item>
                <ScufFooter.Item href="https://pages1.honeywell.com/GlobalHoneywellUnsubscribe.html" >{globalUnsubscribe}</ScufFooter.Item>
            </ScufFooter>
            </div>
        </div>
    );
}
export default Footer;
